// Icon Library - Only import the icons you actually use
// This enables tree-shaking to keep bundle size minimal
import { library } from '@fortawesome/fontawesome-svg-core';

// Import only the specific icons we need
import {
  // Profile & User icons
  faTrophy,
  faStar,
  faUser,
  faEnvelope,
  faShield,
  faShieldAlt,
  faCalendar,
  faClock,
  faUserCircle,
  faUsers,
  faCrown,

  // Quest icons
  faBullseye,
  faFlag,
  faCheckCircle,
  faTimesCircle,
  faCircle,
  faCoins,
  faFire,
  faChartLine,
  faChartBar,
  faChartPie,
  faPlay,
  faPause,
  faTasks,
  faHistory,
  faScroll,
  faPercent,
  faTag,
  faBolt,
  faCompass,
  faMap,
  faHourglassHalf,

  // UI icons
  faSignOutAlt,
  faGlobe,
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
  faCheck,
  faTimes,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faEye,
  faEyeSlash,
  faSpinner,
  faHome,
  faSearch,
  faLock,
  
  // Action icons
  faPlus,
  faMinus,
  faEdit,
  faTrash,
  faSave,
  faUndo,
  faClipboardList,
  
  // Social/External links
  faExternalLinkAlt,
  faLink,
  
  // File icons
  faImage,
  faFilePdf,
  faFileExcel,
  faFileAlt,
  faDownload,
  faFileWord,
  
} from '@fortawesome/free-solid-svg-icons';

import {
  // Regular (outline) versions for variety
  faCircle as faCircleRegular,
  faCheckCircle as faCheckCircleRegular,
  faClock as faClockRegular,
} from '@fortawesome/free-regular-svg-icons';

import {
  // Brand icons
  faTwitch,
} from '@fortawesome/free-brands-svg-icons';

// Add icons to the library
library.add(
  // Profile & User icons
  faTrophy,
  faStar,
  faUser,
  faEnvelope,
  faShield,
  faShieldAlt,
  faCalendar,
  faClock,
  faClockRegular,
  faUserCircle,
  faUsers,
  faCrown,
  
  // Quest icons
  faBullseye,
  faFlag,
  faCheckCircle,
  faCheckCircleRegular,
  faTimesCircle,
  faCircle,
  faCircleRegular,
  faCoins,
  faFire,
  faChartLine,
  faChartBar,
  faChartPie,
  faPlay,
  faPause,
  faTasks,
  faHistory,
  faScroll,
  faPercent,
  faTag,
  faBolt,
  faCompass,
  faMap,
  faHourglassHalf,

  // UI icons
  faSignOutAlt,
  faGlobe,
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
  faCheck,
  faTimes,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faEye,
  faEyeSlash,
  faSpinner,
  faHome,
  faSearch,
  faLock,

  // Action icons
  faPlus,
  faMinus,
  faEdit,
  faTrash,
  faSave,
  faUndo,
  faClipboardList,
  
  // Social/External links
  faExternalLinkAlt,
  faLink,
  faTwitch,
  
  // File icons
  faImage,
  faFilePdf,
  faFileExcel,
  faFileAlt,
  faDownload,
  faFileWord,
);

// Export commonly used icon names for easy reference
export const ICONS = {
  // Profile & User
  TROPHY: 'trophy',
  STAR: 'star',
  USER: 'user',
  USER_CIRCLE: 'user-circle',
  USERS: 'users',
  EMAIL: 'envelope',
  VERIFIED: 'check-circle',
  CALENDAR: 'calendar',
  CLOCK: 'clock',
  CLOCK_REGULAR: ['far', 'clock'],
  CROWN: 'crown',
  
  // Quest
  TARGET: 'bullseye',
  FLAG: 'flag',
  CHECK_CIRCLE: 'check-circle',
  CHECK_CIRCLE_REGULAR: ['far', 'check-circle'],
  TIMES_CIRCLE: 'times-circle',
  CIRCLE: 'circle',
  CIRCLE_REGULAR: ['far', 'circle'],
  COINS: 'coins',
  FIRE: 'fire',
  CHART: 'chart-line',
  CHART_LINE: 'chart-line',
  CHART_BAR: 'chart-bar',
  CHART_PIE: 'chart-pie',
  PLAY: 'play',
  PAUSE: 'pause',
  TASKS: 'tasks',
  HISTORY: 'history',
  SCROLL: 'scroll',
  PERCENT: 'percent',
  TAG: 'tag',
  BOLT: 'bolt',
  COMPASS: 'compass',
  MAP: 'map',
  HOURGLASS: 'hourglass-half',
  
  // UI
  LOGOUT: 'sign-out-alt',
  GLOBE: 'globe',
  EXCLAMATION: 'exclamation-circle',
  EXCLAMATION_TRIANGLE: 'exclamation-triangle',
  INFO: 'info-circle',
  INFO_CIRCLE: 'info-circle',
  CHECK: 'check',
  TIMES: 'times',
  CHEVRON_DOWN: 'chevron-down',
  CHEVRON_UP: 'chevron-up',
  CHEVRON_LEFT: 'chevron-left',
  CHEVRON_RIGHT: 'chevron-right',
  EYE: 'eye',
  EYE_SLASH: 'eye-slash',
  SPINNER: 'spinner',
  HOME: 'home',
  SEARCH: 'search',
  LOCK: 'lock',
  
  // Actions
  PLUS: 'plus',
  MINUS: 'minus',
  EDIT: 'edit',
  TRASH: 'trash',
  SAVE: 'save',
  UNDO: 'undo',
  CLIPBOARD_LIST: 'clipboard-list',
  
  // Social/External
  EXTERNAL_LINK: 'external-link-alt',
  LINK: 'link',
  TWITCH: ['fab', 'twitch'],
  
  // File types
  IMAGE: 'image',
  FILE_PDF: 'file-pdf',
  FILE_EXCEL: 'file-excel',
  FILE_ALT: 'file-alt',
  FILE: 'file-alt',
  FILE_WORD: 'file-word',
  DOWNLOAD: 'download',
  
  // Admin specific
  SHIELD: 'shield',
  SHIELD_ALT: 'shield-alt',
}; 